var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "field",
      class: {
        required: _vm.allowEdit && _vm.isFieldRequired,
        error: _vm.hasScopeError
      }
    },
    [
      _c("label", { attrs: { for: _vm.field.name } }, [
        _vm._v(_vm._s(_vm.field.name))
      ]),
      _vm._v(" "),
      _vm.field.type !== "select" && _vm.field.type !== "textarea"
        ? _c(
            "div",
            {
              staticClass: "ui input",
              class: {
                transparent: _vm.transparent,
                disabled: !_vm.isFieldEditable,
                "corner labeled": _vm.isFieldRequired
              }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: _vm.isFieldRequired },
                    expression: "{ required: isFieldRequired }"
                  }
                ],
                attrs: {
                  type: _vm.field.type,
                  "data-vv-scope": _vm.scope,
                  name: _vm.field.name,
                  readonly: !_vm.allowEdit,
                  "data-vv-value-path": _vm.fieldValue,
                  disabled: !_vm.isFieldEditable
                },
                domProps: { value: _vm.fieldValue },
                on: {
                  input: function($event) {
                    return _vm.updateFieldValue($event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _vm.allowEdit && _vm.isFieldRequired
                ? _c("div", { staticClass: "ui corner label" }, [
                    _c("i", { staticClass: "asterisk icon" })
                  ])
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.field.type === "textarea"
        ? _c(
            "div",
            {
              staticClass: "ui input",
              class: {
                transparent: _vm.transparent,
                disabled: !_vm.isFieldEditable,
                "corner labeled": _vm.isFieldRequired
              }
            },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: _vm.isFieldRequired },
                    expression: "{ required: isFieldRequired }"
                  }
                ],
                class: {
                  disabled: !_vm.isFieldEditable,
                  "non-resizable": !_vm.allowEdit
                },
                attrs: {
                  "data-vv-scope": _vm.scope,
                  name: _vm.field.name,
                  readonly: !_vm.allowEdit,
                  "data-vv-value-path": _vm.fieldValue,
                  disabled: !_vm.isFieldEditable,
                  cols: "30",
                  rows: "10"
                },
                domProps: { value: _vm.fieldValue },
                on: {
                  input: function($event) {
                    return _vm.updateFieldValue($event.target.value)
                  }
                }
              })
            ]
          )
        : _vm.field.type === "select"
        ? _c("semantic-form-dropdown", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: _vm.isFieldRequired },
                expression: "{ required: isFieldRequired }"
              }
            ],
            class: { disabled: !_vm.isFieldEditable },
            attrs: {
              value: _vm.fieldValue,
              "data-vv-scope": _vm.scope,
              disabled: !_vm.allowEdit,
              name: _vm.field.name,
              options: _vm.getSelectOptions,
              required: _vm.field.required,
              multiple: _vm.multiple,
              settings: _vm.settings,
              placeholder: _vm.placeholder
            },
            on: { "dropdown-selected": _vm.updateFieldValue }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hasScopeError
        ? _c("span", { staticStyle: { color: "red" } }, [
            _vm._v(_vm._s(_vm.getScopeError))
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.hasScopeError ? _vm._t("subMessage") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a2f7ffa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a2f7ffa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Field.vue
// module id = uv1f
// module chunks = 1